import React from 'react';
import { Badge } from '@/components/ui/badge';

export const WA_STATUS = {
  open: { label: 'Abierto', cls: 'bg-blue-500/15 text-blue-300 border-blue-500/30' },
  in_progress: { label: 'En progreso', cls: 'bg-amber-500/15 text-amber-300 border-amber-500/30' },
  resolved: { label: 'Resuelto', cls: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30' },
  closed: { label: 'Cerrado', cls: 'bg-slate-500/15 text-slate-300 border-slate-500/30' },
};
export const WA_PRIORITY = {
  low: { label: 'Baja', cls: 'bg-slate-500/15 text-slate-300 border-slate-500/30' },
  normal: { label: 'Normal', cls: 'bg-sky-500/15 text-sky-300 border-sky-500/30' },
  high: { label: 'Alta', cls: 'bg-orange-500/15 text-orange-300 border-orange-500/30' },
  urgent: { label: 'Urgente', cls: 'bg-red-500/15 text-red-300 border-red-500/30' },
};
export const WA_CATEGORIES = ['registro', 'acceso', 'error', 'pagos', 'configuracion', 'otro'];

export function WaBadge({ map, value, testid }) {
  const m = map[value];
  return <Badge variant="outline" className={m?.cls || ''} data-testid={testid}>{m?.label || value || '—'}</Badge>;
}
